<template>
  <div>
    <NavHeader :activeIndex="'MemberBenefits'" />


    <div class="card-content mt-20 ">
      <section>
        <!-- title text and switch button -->
        <div class="text-center">
          <h1 class="mt-5 e_font_family">
            会员权益
          </h1>
          <p class="mb-2 pb-75">

          </p>
        </div>
        <!--/ title text and switch button -->

        <!-- pricing plan cards -->
        <b-row class="pricing-card">
          <b-col offset-sm-2 sm="10" md="12" offset-lg="2" lg="10" class="mx-auto">
            <b-row>
              <b-col md="4" v-for="item in viplist" :key="item.id">
                <b-card class="popular" align="center">
                  <div v-show="item.type == 'year'" class="pricing-badge text-right">
                    <b-badge variant="light-primary" pill>
                      推荐
                    </b-badge>
                  </div>
                  <div v-show="item.type == 'month'" class="pricing-badge text-right">
                    <b-badge variant="light-info" pill>
                      限时
                    </b-badge>
                  </div>
                  <div v-show="item.type == 'season'" class="pricing-badge text-right">
                    <b-badge variant="light-danger" pill>
                      特惠
                    </b-badge>
                  </div>
                  <h1 class="e_font_family">{{ item.title }}</h1>
                  <b-card-text> {{ item.days }} 天 使用时长</b-card-text>

                  <!-- annual plan -->
                  <div class="annual-plan">
                    <div class="plan-price mt-2">
                      <sup class="font-medium-1 font-weight-bold text-primary">￥</sup>
                      <span class="pricing-basic-value font-weight-bolder text-primary">{{ item.price }}</span>
                      <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/{{ item.type }}</sub>
                    </div>
                    <small class="annual-pricing text-muted">
                      限时优惠，<span style="text-decoration: line-through;">原价：{{ item.opirce }}</span>
                    </small>
                  </div>
                  <!--/ annual plan -->

                  <!-- plan benefit -->
                  <b-list-group class="list-group-circle text-left e_font_family">
                    <b-list-group-item>
                      走地大小球预测
                    </b-list-group-item>
                    <b-list-group-item>
                      走地让球球预测
                    </b-list-group-item>
                    <b-list-group-item>
                      走地角球预测
                    </b-list-group-item>
                    <b-list-group-item>
                      初盘大小球预测
                    </b-list-group-item>
                    <b-list-group-item>
                      初盘让球预测
                    </b-list-group-item>
                    <b-list-group-item>
                      初盘角球预测
                    </b-list-group-item>
                  </b-list-group>
                  <!--/ plan benefit -->

                  <!-- buttons -->
                  <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" block class="mt-2" variant="primary">
                    快速开始
                  </b-button>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!--/ pricing plan cards -->

        <div
          class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
          <div class="row align-items-center text-center e_font_family">
            <div class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex align-items-center justify-content-center ">
              <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12 align-items-center justify-content-center ">
                <div class="text-center text-md-left mt-3 ms-lg-20 ">
                  <h3 class="text-primary">
                    🔥【即刻掌握赛果先机】🔥
                  </h3>
                  <h5>厌倦了比赛前的盲目猜测？SoccerPredictor，您的专属足球数据分析大师，</h5>
                  <h5>即刻解锁海量赛事数据，精准预测，
                    让每一场足球盛宴尽在您的掌握之中。</h5>
                  <h3 class="text-primary mt-5">
                    📊【深度数据，精准预测】📊
                  </h3>
                  <h5>我们深谙足球的魅力在于未知，但SoccerPredictor以强大的数据分析能力，为您揭开胜利的迷雾。</h5>
                  <h5>从球队状态到球员表现，从战术布局到历史交锋，一切尽在掌握。让数据说话，让预测更精准！</h5>
                  <h3 class="text-primary mt-5">
                    🌐【全球赛事，一网打尽】🌐
                  </h3>
                  <h5>论您是关注五大联赛、欧冠激战，还是热爱小众赛事，SoccerPredictor都能满足您的需求。</h5>
                  <h5>全球赛事覆盖，实时更新，让您随时随地，与世界足球脉搏同频共振。</h5>

                  <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-2 mt-lg-3">
                    👉[快速下载SoccerPredictor]👈
                  </b-button>
                </div>
              </div>

              <div class="col-5 d-none d-lg-flex align-items-center p-5 ">
                <div class=" d-lg-flex align-items-center justify-content-center px-5 mt-10 ">
                  <img class="animate3" src="@/assets/images/slider/ball1.png" width="50px" alt="img">
                  <img src="@/assets/images/slider/h1-layer1.png" width="400px" alt="Slider Layer Image">
                </div>
              </div>


            </div>
          </div>
        </div>


        <!-- pricing faq -->
        <div class="pricing-faq mt-50 e_font_family">
          <h3 class="text-center">
            常见问题
          </h3>
          <p class="text-center">

          </p>
          <b-row class="py-2">
            <b-col lg="10" offset-lg="2" class="mx-auto">
              <app-collapse accordion type="margin" >
                <app-collapse-item title="你们这个平台胜率高吗?">
                  首先，胜率分为表面胜率和实际胜率，实话实说，长期实际胜率目前任何产品实际都达不到80%以上，不然某些公司早就破产了，
                  当然，有些看起来很虚的玩法就另说，他们表面胜率可以达到80%甚至更多。
                  那我们的产品目前月平均实际胜率大概稳定在70%上下，有些时候也能达到80%甚至以上，长期目前就稳定在70%那么多.
                </app-collapse-item>
                <app-collapse-item title="你们的数据靠不靠谱？会不会提示出来找不到对应的盘口？">
                  胜率首先是第一位，那实际操作又是另外一个层次，我们的赛事数据都是从国外实时采集的，对应的盘口和水位也是实时更新的，那我们提示出来的数据，
                  市面上就肯定能找到，比如我们提示大小球盘口是2.5/3，那就肯定是有的.
                </app-collapse-item>
                <app-collapse-item title="你们软件能干什么?">
                  我们提供专业的足球数据分析，包括不仅限于：走地大小球、走地让球，走地角球预测。
                </app-collapse-item>
                <app-collapse-item title="你们的软件用了什么模型算法?">
                  其实现在主流的机器学习、深度学习，模型都是那几个，包括Elo预测法、进球率预测法、机器学习模型、深度学习模型等，
                  其实算法不值钱，值钱的是怎么去处理数据，让大模型能够更好的理解你的想法，
                  举个简单的栗子，同样的模型，你只拿进攻数和控球率去训练，那多好的算法，预测都不可能靠谱，但是如果你数据很丰富，那么这个胜率就高很多了,
                  我们团队有专业的足球大师级别专家，从事行业10余年，提供给大模型的数据都是经过长期打磨的.
                </app-collapse-item>
                <app-collapse-item title="你们软件会不会连黑，最黑是多黑?">
                  别人不敢说，我们敢说，
                  当然会连黑，哪个软件敢说自己不会连黑，耶稣都不敢保证稳赢，
                  但是我们黑也是小黑，很少概率出现一天黑个几十场，长期胜率还是有保障。主打的就是稳定长红。
                </app-collapse-item>
                <app-collapse-item title="你们的软件可以试用吗?">
                  好多人都会说，不给试用都是割韭菜的，说的很有道理，我们表示完全认同，
                  只不过我们暂时秉着对会员权益的保护，所以暂时还没开放，后期会考虑每天定时免费1-3场这样的模式.
                </app-collapse-item>
                <app-collapse-item title=" 怎么使用你们产品?">
                  首先得先下载软件，然后注册支付开通即可。当有新的预测数据，平台会通过多种方式提示，比如设置声音提醒、邮箱提醒、界面消息提醒等，操作简单，便捷。
                </app-collapse-item>
                <app-collapse-item title="你们有手机版吗?">
                  我们提供电脑版和手机版的操作平台，电脑版是安装包，手机版是网页版，下载界面有二维码，直接用微信可以直接打开。推荐试用电脑版，效果更佳！
                </app-collapse-item>
              </app-collapse>
            </b-col>
          </b-row>
        </div>
        <!--/ pricing faq -->
      </section>
    </div>
  </div>
</template>

<script>
import NavHeader from './NavHeader.vue'
import Ripple from 'vue-ripple-directive'
import request from '@/utils/request.js';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    NavHeader,
    AppCollapse,
    AppCollapseItem
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      viplist: [],
    }
  },
  computed: {


  },
  created() {
    this.getCardList();
  },

  methods: {
    goDwonload() {
      this.$router.push("/DownLoad");
    },
    async getCardList() {
      let post_url = 'football/admin/william/interfaceAction!getCardList.action';
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      request.httpRequest(opts).then(response => {

        if (response == null) {
          this.$message.error('网络连接异常');
          return;
        }
        if (response.data.status == 0) {
          this.$message.error(response.data.message);
          return;
        }
        this.viplist = response.data.cardList
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-pricing.scss';

.e_font_family {
  font-family: PingFangSC-Regular, Microsoft YaHei, Heiti, Arial, Helvetica, "sans-serif" !important;
}
</style>
